module.exports = __webpack_public_path__ + "img/cover-2.ff4f4a91.jpg";